import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// import { BrowserRouter, Routes, Route } from "react-router-dom"
// import { userRoutes } from "./Routes/allRoutes"
// import './assets/css/sora-font.css'
// import './App.css';
// import './assets/css/bootstrap-icons.css';
// import './assets/css/bootstrap.min.css';
// import './assets/css/fonts.css';
// import './assets/css/custom.css';
// import './assets/js/scripts.js';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
